export const config = {
  src: [
    'audiosprites/audio.ogg',
    'audiosprites/audio.mp3',
  ],
  sprite: {
    big_win: [
      0,
      7243.174603174603,
    ],
    bonus_bandit_wins: [
      9000,
      4268.1179138321995,
    ],
    bonus_sherif_wins: [
      15000,
      4448.072562358277,
    ],
    button_spin: [
      21000,
      898.3219954648512,
    ],
    coins: [
      23000,
      1207.437641723356,
    ],
    delorian_splash_screen: [
      26000,
      7286.712018140591,
    ],
    free_bet_big_win: [
      35000,
      1377.2335600907013,
    ],
    free_bet_mega_win: [
      38000,
      2213.151927437643,
    ],
    free_bet_total_win: [
      42000,
      979.5918367346915,
    ],
    free_bet_ultra_win: [
      44000,
      1319.1836734693893,
    ],
    free_spin_ambient: [
      47000,
      48027.573696145126,
    ],
    free_spin_music: [
      97000,
      68263.76417233558,
    ],
    free_spin_start: [
      167000,
      5571.337868480725,
    ],
    fs_end_popup: [
      174000,
      2407.6190476190504,
    ],
    idle_bonus_game: [
      178000,
      4030.1133786848027,
    ],
    inside_buttons: [
      184000,
      326.530612244909,
    ],
    main_ambient: [
      186000,
      87012.42630385491,
    ],
    main_music: [
      275000,
      122538.95691609978,
    ],
    mega_win: [
      399000,
      7875.918367346912,
    ],
    music_bonus_game: [
      408000,
      12696.961451247149,
    ],
    outside_buttons: [
      422000,
      503.5827664399335,
    ],
    reel_spin: [
      424000,
      2201.5419501133806,
    ],
    reel_stop_01: [
      428000,
      259.7732426303878,
    ],
    reel_stop_02: [
      430000,
      251.0657596371857,
    ],
    reel_stop_03: [
      432000,
      282.9931972789268,
    ],
    reel_stop_04: [
      434000,
      245.26077097505095,
    ],
    reel_stop_05: [
      436000,
      248.16326530611832,
    ],
    regular_win: [
      438000,
      1513.650793650811,
    ],
    respin: [
      441000,
      6189.569160997735,
    ],
    scatter_stop: [
      449000,
      1252.426303854861,
    ],
    select_free_spin: [
      452000,
      8941.13378684807,
    ],
    tap_to_play: [
      462000,
      6029.931972789143,
    ],
    train_land: [
      470000,
      6331.791383219979,
    ],
    train_port: [
      478000,
      6131.519274376444,
    ],
    ultra_win: [
      486000,
      6624.943310657613,
    ],
  },
}
